import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Import the Firebase configuration
import firebaseConfig from '../firebase-applet-config.json';

// Initialize Firebase SDK
const { firestoreDatabaseId, ...firebaseOptions } = firebaseConfig;
const app = initializeApp(firebaseOptions);

// If database ID is empty or "(default)", omit it to connect to the default database
console.log('CONFIG: firestoreDatabaseId:', firestoreDatabaseId);
const dbId = (firestoreDatabaseId && firestoreDatabaseId !== "(default)" && firestoreDatabaseId !== "")
    ? firestoreDatabaseId
    : undefined;

console.log('DEBUG: dbId determined to be:', dbId);
export const db = dbId ? getFirestore(app, dbId) : getFirestore(app);
console.log('Firestore initialized with dbId:', dbId, 'projectId:', firebaseOptions.projectId);
export const auth = getAuth();

import { doc, getDocFromServer } from 'firebase/firestore';

async function testConnection() {
  try {
    console.log('Testing Firestore connection to database:', firebaseConfig.firestoreDatabaseId);
    // Use a lightweight call to check if we can reach the backend
    await getDocFromServer(doc(db, '_connection_test_', 'ping')).catch(err => {
        // If it's just "not found", that's okay, the collection might be empty.
        // But "permission-denied" is a critical failure.
        if (err.code === 'not-found') return;
        throw err;
    });
    console.log('Firestore connection successful');
  } catch (error) {
    if (error instanceof Error) {
      if (error.message.includes('the client is offline') || error.message.includes('Could not reach')) {
        console.error("CRITICAL: Firestore is offline. Please check if the Firebase project and database are fully provisioned.");
      } else {
        console.error("Firestore connection failed due to:", error);
      }
    }
  }
}

// Fire and forget, don't block initialization
testConnection();
